$(document).on("change", ".bundle-variant-dropdown", function () {
  var varImg = $(this).find("option:selected").attr("data-variant-image");
  var main_price_js = $(this).find("option:selected").attr("data-main-price");
  var compare_price_js = $(this).find("option:selected").attr("data-comp-price");
  var VarId = $(this).find("option:selected").attr("value");

  if (varImg != "") {
    $(this).closest(".p_bundle_list").find(".p_bundle_img img").attr("src", varImg);
  }

  if (main_price_js != "") {
    const $regularPriceWrapper = $(this)
      .closest(".p_bundle_list")
      .find(".p_bundle_price .p_regular_price");

    if (parseInt(main_price_js) === 0) {
      $regularPriceWrapper.html('<span class="money">Free</span>');
    } else {
      $regularPriceWrapper.html(
        Shopify.formatMoney(main_price_js, $("body").data("money-format"))
      );
    }

    $(this)
      .closest(".p_bundle_list")
      .find(".p_bundle_price")
      .attr("data-price", main_price_js);
  }

  if (compare_price_js != "") {
    $(this)
      .closest(".p_bundle_list")
      .find(".p_bundle_price .p_old_price .money")
      .text(Shopify.formatMoney(compare_price_js, $("body").data("money-format")));

    $(this)
      .closest(".p_bundle_list")
      .find(".p_bundle_price")
      .attr("data-comp-price", compare_price_js);
  }

  if (VarId != "") {
    $(this).closest(".p_bundle_list").attr("data-id", VarId);
  }

  var main_total = 0;
  var comp_total = 0;

  $(".bundle_1 .p_bundle_price").each(function () {
    var main = parseInt($(this).attr("data-price")) || 0;
    var comp = parseInt($(this).attr("data-comp-price")) || main;
    main_total += main;
    comp_total += comp;
  });

  var discountPct = parseFloat($('.bundle_1').data('discount')) / 100;
  var discount = Math.round(main_total * discountPct);
  var discounted_price = main_total - discount;

  $(".bundle_1 .p_bundle_discount").html(
    Shopify.formatMoney(main_total, $("body").data("money-format"))
  );
  $(".bundle_1 .p_bundle_final_price").html(
    Shopify.formatMoney(discounted_price, $("body").data("money-format"))
  );
});

$(document).on("click", ".b_add_to_cart", function () {
  let arr = [];
  var timestamp = Math.round(new Date().getTime() / 1000);

  $(this)
    .closest(".accordion")
    .find(".p_bundle_list")
    .each(function () {
      var vId = $(this).attr("data-id");

      if ($(this).hasClass("free_initials")) {
        var initials = $(this).find('input[name="free_initials"]').val();
        arr.push({
          id: vId,
          quantity: 1,
          properties: {
  _bundle: "bundle-" + timestamp,
  _revyBundleInfo: "bundle-" + timestamp,
  Initials: initials,
},

        });
      } else {
        arr.push({
          id: vId,
          quantity: 1,
          properties: {
            _bundle: "bundle-" + timestamp,
          },
        });
      }
    });

  let formData = { items: arr };

  fetch("/cart/add.js", {
    body: JSON.stringify(formData),
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "xmlhttprequest",
    },
    method: "POST",
  })
    .then((response) => response.json())
    .then(() => {
      location.href = "/cart";
    })
    .catch((err) => {
      console.error(err);
    });
});

$(document).ready(function () {
  $('.accordion.bundle_1 .tab_content').show();
});

$(document).on('click', '.accordion.bundle_1 .ac-title', function (e) {
  e.stopPropagation();
  return false;
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('header-menu details').forEach((details) => {
    let closeTimer;

    details.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
    });

    details.addEventListener('mouseleave', (e) => {
      // Check if moving toward the mega menu content
      closeTimer = setTimeout(() => {
        details.removeAttribute('open');
      }, 400);
    });

    // Cancel close if cursor enters the menu content
    const content = details.querySelector('.mega-menu__content, .header__submenu');
    if (content) {
      content.addEventListener('mouseenter', () => clearTimeout(closeTimer));
      content.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => {
          details.removeAttribute('open');
        }, 400);
      });
    }
  });
});
